/**
 * Spread these props onto any <input> that should NOT be autofilled by
 * browsers / password managers. Mobile Safari + Samsung Internet +
 * 1Password + LastPass all trip on unrelated text inputs otherwise and
 * pop up save-password suggestions mid-form — especially annoying on
 * numeric score inputs that look suspiciously like OTP codes.
 *
 *     <input {...noAutofill} … />
 */
export const noAutofill = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "data-1p-ignore": "",
  "data-lpignore": "true",
  "data-form-type": "other",
} as const;
